import React from 'react';

import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerWorkspace from '../../../../components/ContainerConteudo';
import subAbas from '../subabas';

const HomeAlerta: React.FC = () => {
  return (
    <>
      <BarraSubAbas subAbas={subAbas} />
      <ContainerWorkspace>
        <b>Alertas</b>
      </ContainerWorkspace>
    </>
  );
};

export default HomeAlerta;
